/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { UserButton } from '@clerk/clerk-react';
import { Fingerprint, ReceiptText, Wrench } from 'lucide-react';

import { Skeleton } from '@/components/ui/skeleton';

type UserNavProps = {
    hasAdminPermissions?: boolean;
};

export const UserNav = ({ hasAdminPermissions }: UserNavProps) => {
    return (
        <UserButton
            appearance={{ elements: { avatarBox: 'h-8 w-8' } }}
            fallback={<Skeleton className="h-8 w-8 rounded-full" />}
        >
            <UserButton.MenuItems>
                <UserButton.Link label="Organisation" labelIcon={<Wrench size={14} />} href="/organisation/general" />
                <UserButton.Link label="Terms & Privacy policy" labelIcon={<ReceiptText size={14} />} href="/terms" />
                {hasAdminPermissions && (
                    <UserButton.Link label="Admin" labelIcon={<Fingerprint size={14} />} href="/admin" />
                )}
            </UserButton.MenuItems>
        </UserButton>
    );
};
